/* ============================================================
   HEMP LIFE - product rail arrows (Gravity XL)

   Progressive enhancement. The buttons ship with the `hidden`
   attribute set, so with JS off - or on a rail short enough to
   fit - nothing is shown and the rail is still swipeable and
   scrollable exactly as before.

   Everything is wrapped so a failure here can never take down
   another script on the page.
   ============================================================ */
(function () {
  'use strict';

  var REDUCED = false;
  try {
    REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  } catch (e) { /* older browser, keep smooth scrolling */ }

  function setup(root) {
    var track = root.querySelector('[data-hl-rail-track]');
    var prev = root.querySelector('[data-hl-rail-prev]');
    var next = root.querySelector('[data-hl-rail-next]');
    if (!track || !prev || !next) return;

    /* One click moves a whole screenful of cards, not a single card -
       clicking four times to reveal one new product is the thing that
       makes carousel arrows feel broken. */
    function stepSize() {
      var card = track.firstElementChild;
      if (!card) return track.clientWidth;
      var gap = 0;
      try {
        gap = parseFloat(window.getComputedStyle(track).columnGap) || 0;
      } catch (e) { gap = 0; }
      var unit = card.getBoundingClientRect().width + gap;
      if (!unit || unit < 1) return track.clientWidth;
      var perView = Math.max(1, Math.floor((track.clientWidth + gap) / unit));
      return unit * perView;
    }

    function maxScroll() {
      return Math.max(0, track.scrollWidth - track.clientWidth);
    }

    function sync() {
      var max = maxScroll();
      var scrolls = max > 4;
      prev.hidden = !scrolls;
      next.hidden = !scrolls;
      if (!scrolls) return;
      prev.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft >= max - 2;
    }

    function go(direction) {
      track.scrollBy({
        left: direction * stepSize(),
        behavior: REDUCED ? 'auto' : 'smooth'
      });
    }

    prev.addEventListener('click', function () { go(-1); });
    next.addEventListener('click', function () { go(1); });
    track.addEventListener('scroll', sync, { passive: true });

    /* The buttons are absolutely positioned overlays, so toggling them
       cannot change the track's box - no observer feedback loop. */
    if (typeof window.ResizeObserver === 'function') {
      new window.ResizeObserver(sync).observe(track);
    } else {
      window.addEventListener('resize', sync);
    }

    /* Images landing late change scrollWidth after first paint. */
    window.addEventListener('load', sync);

    sync();
  }

  function init() {
    try {
      var rails = document.querySelectorAll('[data-hl-rail]');
      for (var i = 0; i < rails.length; i++) {
        if (rails[i].getAttribute('data-hl-rail-ready')) continue;
        rails[i].setAttribute('data-hl-rail-ready', '1');
        setup(rails[i]);
      }
    } catch (e) { /* never break the page over a carousel arrow */ }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Theme editor re-renders a section without a page load. */
  document.addEventListener('shopify:section:load', init);
})();
